(() => {
    angular
        .module('summaryModule', ['ngAnimate', 'journey.canvas.srv'])
        .controller('summaryCtrl', ['$scope', '$rootScope', '$timeout', 'canvasService', 'helpers', '$sce', '$templateCache', '$compile',  ($scope, $rootScope, $timeout, canvasService, helpers, $sce, $templateCache, $compile) => {
            $scope.mainView = true;
            $scope.innerView = false;
            $scope.innerView2 = false;
            $scope.summary = false;
            $scope.summaryData = {};
            $scope.summaryAllData = {};

            $rootScope.$watch('translate', (func) => {
                if(func) {
                    $scope.translate = func;
                }
            });

            $rootScope.$on('setBodyOverflow', () => { $scope.overflowHidden = true; });

            $rootScope.$on('summary', (e, display, id, title, emailName, days, hideClose, nodeMetricFlag, nodeReportInfo) => {
                //Node Metrics
                $scope.currentId = id;
                $scope.nodeReportInfo = nodeReportInfo || [];
                $scope.contactsToRender = [];
                $scope.loadingContacts = true;
                $scope.nodeMetricFlag = nodeMetricFlag;
                $scope.currentMetricType = nodeReportInfo && nodeReportInfo.length && nodeReportInfo[1].MetricTypeSummaries.length ? nodeReportInfo[1].MetricTypeSummaries[0].MetricType : '';
                $scope.currentCount = 0;
                $scope.minBigCount = 150000;

                //Reset pagination
                $scope.metricsPagination.currentPage = 0;
                $scope.metricsPagination.pageSize = '10';
                $scope.metricsPagination.pages = 0;

                //Reset search
                $scope.metricsSearch.value = '',
                $scope.metricsSearch.isActive = false,
                $scope.metricsSearch.expanded = false,

                $scope.hideClose = hideClose;
                $scope.activeDays = $rootScope.activeDays || days;
                if(emailName) {
                    $scope.mainView = false;
                    $scope.innerView = true;
                } else {
                    $scope.mainView = true;
                    $scope.innerView = false
                    Intercom('trackEvent', 'AP - Summary');
                }

                if ($scope.currentMetricType) {
                    $scope.currentCount = nodeReportInfo[1].MetricTypeSummaries.find((summary) => summary.MetricType === $scope.currentMetricType).Count;
                }

                $scope.emptyState = false;

                $scope.innerView2 = false;
                $scope.title = title;
                $scope.summary = display;
                $scope.loading = true;

                if($scope.summaryAllData[id] && $scope.summaryAllData[id].Summary) {
                    $scope.summaryData = $scope.summaryAllData[id];
                    $scope.currentId = id;

                    if (!$scope.summaryData.Summaries.length) {
                        $scope.emptyState = true;
                    }

                    if (emailName) {
                        let summaries = $scope.summaryData.Summaries.find((i) => {
                            const find = i.Summaries.find((j) => {
                                if (j.TemplateName == emailName) {
                                    return true;
                                }
                            });
                            if (find) return i;
                        });
                        const summary = summaries ? summaries.Summaries.filter((i) => {
                            if (i.TemplateName == emailName) {
                                return i;
                            }
                        }) : [];
                        $scope.goInner(summary[1] || summary[0], summaries);
                    }

                    $scope.loading = false;
                } else {
                    canvasService
                        .getAllSummaryReports(id)
                        .then(({data}) => {
                            $scope.summaryAllData[id] = data.Result;
                            $scope.summaryData = $scope.summaryAllData[id];
                            $scope.currentId = id;

                            if (!$scope.summaryData.Summaries.length) {
                                $scope.emptyState = true;
                            }

                            if (emailName) {
                                let summaries = $scope.summaryData.Summaries.find((i) => {
                                    const find = i.Summaries.find((j) => {
                                        if (j.TemplateName == emailName) {
                                            return true;
                                        }
                                    });
                                    if (find) return i;
                                });
                                const summary = summaries && summaries.Summaries.filter((i) => {
                                    if (i.TemplateName == emailName) {
                                        return i;
                                    }
                                }) || [];

                                $scope.goInner(summary[1] || summary[0], summaries);
                            }

                            $scope.loading = false;
                        });
                }

                if ($scope.nodeReportInfo.length && $scope.nodeReportInfo[1].MetricTypeSummaries.length) {
                    $scope.showMetricNodeDetail($scope.nodeReportInfo[1].MetricTypeSummaries[0].MetricType);
                } else {
                    $scope.loadingContacts = false;
                }

                $rootScope.$emit('setBodyOverflow');
            });

            $scope.close = () => {
                $scope.summary = false;
                $rootScope.$emit('removeBodyOverflow');
            };

            $scope.goInner = (summary, summaries) => {
                $scope.innerSummary = summary;
                $scope.innerVersions = summaries && summaries.Summaries;
                $scope.mainView = false;
                $scope.innerView2 = false;
                $scope.innerDetails = false;
                $scope.innerView = true;

                $scope.innerSummary &&
                canvasService.getEmailDetails( $scope.innerSummary.EmailId).then(({data}) => { $scope.eDetails = data; });
            };

            $scope.goBackInner = () => {
                $scope.mainView = false;
                $scope.innerView2 = false;
                $scope.innerDetails = false;
                $scope.pagination.pages = 0;
                $scope.innerView = true;
            };

            $scope.goBack = () => {
                $scope.innerView = false;
                $scope.innerView2 = false;
                $scope.innerDetails = false;
                $scope.mainView = true;
                Intercom('trackEvent', 'AP - Summary');
            };

            $scope.isMetricTypeAvailable = function(metricType) {
                const isMetricAvailable = $scope.nodeReportInfo[1].AvailableMetricTypes.some((availableMetricType) => availableMetricType.MetricType === metricType);
                return isMetricAvailable;
            }

            $scope.renderMetricType = function(metricType) {
                const metric = $scope.nodeReportInfo[1].AvailableMetricTypes.find((element) => element.MetricType === metricType).Name;
                return metric;
            };

            $scope.showMetricNodeDetail = function(metricType) {
                $scope.currentMetricType = metricType;
                $scope.loadingContacts = true;
                $scope.contactsToRender = [];
                canvasService.getNodeMetricDetailsSummaryByType(
                        $scope.currentId,
                        $scope.nodeReportInfo[0].NodeId,
                        metricType,
                        $scope.metricsPagination.currentPage,
                        $scope.metricsPagination.pageSize,
                        $scope.metricsSearch.value)
                    .then(function(res) {
                        $scope.metricsPagination.pages = Math.ceil(parseInt(res.data.TotalCount) / parseInt($scope.metricsPagination.pageSize))
                        $scope.contactsToRender = res.data.Contacts;
                        $scope.loadingContacts = false;
                    });
            };

            $scope.getNodeName = function() {
                switch ($scope.nodeReportInfo[0].NodeActionType) {
                    case 4:
                        return 'canvas.action.addTolList.title';
                    case 5:
                        return 'canvas.action.removeFromList.title';
                    case 13:
                        return 'canvas.entry.websiteEngagement.title';
                    case 20:
                        return 'canvas.entry.addedToList.title';
                    case 21:
                        return 'canvas.entry.dateTime.title';
                    case 27:
                        return 'canvas.entry.addedToSegment.title';
                    default:
                        return 'commons.loadingMoreResults';
                }
            };

            $scope.goToView2 = (type, shouldDisplaySecondView, sort = 'desc', pageNum = 1) => {
                if(!shouldDisplaySecondView) {
                    return false;
                }
                $scope.innerView2 = true;
                $scope.mainView = false;
                $scope.innerView = false;
                $scope.pagination.currentPage = pageNum;
                $scope.currentType = type;
                $scope.reportsTitle = $scope.getTitleByType(type);
                $scope.reportsOpt = type;
                $scope.innerViewData = [];
                $scope.clickPerformanceData = [];
                $scope.noRecords = false;
                $scope.content = true;

                if(type == 'Clicks') {
                    canvasService.getReportByType($scope.innerSummary.EmailId, 'ClickPerformance')
                        .then(({data}) => {
                            $scope.clickPerformanceData = data.Response.Data;
                            if(!$scope.clickPerformanceData.length) {
                                $scope.clickPerformanceNoRecords = true;
                            }
                        });

                }
                canvasService.getReportByType($scope.innerSummary.EmailId, type, sort, pageNum, $scope.pagination.pageSize)
                    .then(({data}) => {
                        $scope.reportsView = false;
                        $scope.innerViewData = data.Response.Data;
                        $scope.pagination.pages = Math.ceil(data.Response.Count / $scope.pagination.pageSize);

                        if(!$scope.innerViewData.length) {
                            $scope.noRecords = true;
                        }
                    });
            };

            $scope.setSummary = ($index) => {
                $scope.innerSummary = $scope.innerVersions[$index];
                canvasService.getEmailDetails( $scope.innerSummary.EmailId ).then(({data}) => { $scope.eDetails = data; })
                canvasService.generateThumbs( $scope.innerSummary.EmailId).then(() => {});
            };

            $scope.formatPercent = (percent) => {
                percent = percent * 100;
                if(isNaN(percent)) {
                    return '0.00';
                }
                return percent.toFixed(2);
            };

            $scope.summaryView = {
                'sent': true,
                'opened': false,
                'clicks': false,
                'bounces': false,
                'unsubscribes': false
            };
            $scope.showSummaryView = (view) => {
                $scope.resetSummaryView();
                $scope.summaryView[view] = true;
            };

            $scope.resetSummaryView = (view) => {
                $scope.summaryView = {
                    'sent': false,
                    'opened': false,
                    'clicks': false,
                    'bounces': false,
                    'unsubscribes': false
                };
            };

            $scope.saveStats = false;
            $scope.stats = {};
            $scope.stats.enums = {
                Unknow: 0,
                Open: 1,
                Unopen: 2,
                Clicked: 3,
                UnCliked: 4
            };

            $scope.showStats = (type) => {
                let processType = 1;

                if(type == 'Unopens') {
                    processType = 2;
                }

                if(type == 'Clicks') {
                    type = 'LinksClicked';
                    processType = 3;
                }

                $scope.stats.payload = {};
                $scope.stats.payload.JourneyId = $scope.currentId;
                $scope.stats.payload.JourneyVersion = '1';
                $scope.stats.payload.NodeName = $scope.innerSummary.ElementId;
                $scope.stats.payload.ProcessType = processType;
                $scope.stats.payload.ProcessFromType = '1';
                $scope.saveStats = true;
                $scope.summary = false;
                $scope.statType = type;
            };

            $scope.saveStatsAsList = () => {
                if($scope.stats.listName) {

                    Intercom('trackEvent', `AP - ${$scope.statType}-SaveList`);
                    $scope.inputError = false;
                    $scope.duplicateError = false;
                    $scope.stats.payload.ListName = $scope.stats.listName;

                    // This value comes from the beginning of the file
                    $scope.stats.payload.ListId = $scope.eDetails.ToListId;

                    $scope.stats.payload.Version = $scope.summary.apVersion;

                    canvasService.saveStatsAsLists(JSON.stringify($scope.stats.payload))
                        .then((res) => {
                            if(!res.data.ProcessAdded) {
                                $scope.inputError = true;
                                $scope.duplicateError = true;
                            } else {
                                $scope.cancelStats();
                                $rootScope.$emit('errorMsg', $scope.translate('common.list.message'), 'confirmation');
                            }
                        })
                        .catch(() => {
                            $scope.inputError = true;
                            $scope.duplicateError = false;
                            $scope.cancelStats();
                            $rootScope.$emit('errorMsg', 'Something went wrong, try again later.');
                        });
                } else {
                    $scope.inputError = true;
                    $scope.duplicateError = false;
                }
            };

            $scope.cancelStats = () => {
                $scope.saveStats = false;
                $scope.summary = true;
                $scope.innerDetails = true;
                $scope.stats = {};
            };

            $scope.fields = {};
            $scope.pin = '';
            $scope.displayExport = (reportType) => {
                if(!$scope.hasPin || !$scope.fieldData || ($scope.ReportType != reportType)) {
                    $scope.ReportType = reportType;
                    canvasService.getDownloadInfo($scope.innerSummary.EmailId, reportType)
                        .then(({data}) => {
                            let chunks = helpers.createChunks(data.Response.Data, 2);
                            chunks.forEach((field) => {
                                if (field && field[0] && field[0].FieldName == 'email') {
                                    $scope.fields[field[0].FieldName] = true;
                                }
                                else if (field && field[0]) {
                                    $scope.fields[field[0].FieldName] = false;
                                }

                                if (field && field[1] && field[1].FieldName == 'email') {
                                    $scope.fields[field[1].FieldName] = true;
                                } else if (field && field[1]) {
                                    $scope.fields[field[1].FieldName] = false;
                                }
                            });

                            $scope.fieldData = chunks;
                            $scope.hasPin = data.Response.HasPin == 1;
                        });
                }


                $scope.displayExportView = true;
                $scope.summary = false;
            };

            $scope.hideExport = () => {
                $scope.reportsView = false;
                $scope.pinView = false;
                $scope.displayExportView = false;
                $scope.fields = {};
                $scope.checkAll = false;
                $scope.summary = true;
            };


            $scope.getTitleByType = (type) => {
                return {
                    Opens: $scope.translate('reports.openedEmails'),
                    Bounces: $scope.translate('reports.emailsBounced'),
                    Unopens: $scope.translate('reports.unopened'),
                    Clicks: $scope.translate('reports.linksClicked'),
                    Unsubscribes: $scope.translate('reports.unsubscribes'),
                    Abuse: $scope.translate('reports.complaints')
                }[type] || '';
            };

            $scope.sortReports = false;
            $scope.searchWithSort = () => {
                $scope.sortReports = !$scope.sortReports;

                let sort = 'desc';

                if($scope.sortReports) sort = 'asc';

                $scope.goToView2($scope.currentType, true, sort, $scope.pagination.currentPage, $scope.pagination.pageSize);
            };

            $scope.pagination = {
                pages: 1,
                currentPage: 1,
                pageSize: '10'
            };

            $scope.$watch('pagination.pageSize', (newVal, oldVal) => {
                if(newVal != oldVal) {
                    let sort = 'desc';
                    if($scope.sortReports) sort = 'asc';
                    $scope.pagination.currentPage = 1;
                    $scope.goToView2($scope.currentType, true, sort, $scope.pagination.currentPage);
                }
            });

            $scope.nextPage = () => {
                let sort = 'desc';
                if($scope.sortReports) sort = 'asc';

                $scope.pagination.currentPage ++;
                $scope.goToView2($scope.currentType, true, sort, $scope.pagination.currentPage);
            };

            $scope.previousPage = () => {
                let sort = 'desc';
                if($scope.sortReports) sort = 'asc';
                $scope.pagination.currentPage --;
                $scope.goToView2($scope.currentType, true, sort, $scope.pagination.currentPage);
            };

            $scope.downloadFile = (type) => {
                $scope.currentType = type;

                if(!$scope.hasPin) {
                    $scope.pin = '1234';
                }

                if(!$scope.pin) {
                    $scope.pinView = true;
                    $scope.displayExportView = false;
                } else {
                    let payload = {
                            Fields: "",
                            Mode: type,
                            PIN: $scope.pin
                        },
                        fields = Object.keys($scope.fields).filter((key) => {
                            if(key != 'email') {
                                return $scope.fields[key];
                            } else {
                                return false;
                            }
                        }) || [];

                    fields = fields.join(',');

                    canvasService.downloadFile($scope.innerSummary.EmailId, 3, payload)
                        .then(({data}) => {
                            if(data.Response.Status == '-1') {
                                //invalid pin error
                                $scope.pinError = true;
                            } else {
                                $scope.pinError = false;
                                const url = 'https://ui.benchmarkemail.com/Reports/File?mode='+type+'&field='+fields+'&rtype=3&eid='+$scope.innerSummary.EmailId+'&region=&linkname=&seq=&pin=' + $scope.pin;
                                $(location).attr('href', url);

                                $scope.hideExport();
                            }
                        });
                }
            };

            $scope.checkAll = false;
            $scope.selectAll = () => {
                Object.keys($scope.fields).forEach((key) => {
                    if(key == 'email') {
                        $scope.fields[key] = true;
                    } else {
                        $scope.fields[key] = !$scope.fields[key];
                    }
                });
            };

            $scope.sendPin = () => {
                canvasService.emailPin($scope.innerSummary.EmailId)
                    .then(() => {
                        $scope.showPinSent = true;
                    })
            };

            $scope.displayPrevSummary = (eId) => {
                $scope.previewEmailSummary(eId);
                $scope.summaryEmailPreview = true;
                $timeout(()=> {
                    $scope.summaryEmailPreviewIn = true;
                }, 300);
            };

            $scope.closePreviewModal = () => {
                $scope.summaryEmailPreviewIn = false;
                $timeout(()=> {
                    $scope.summaryEmailPreview = false;
                }, 300);
            };

            $scope.previewEmailSummary = function (eId) {
                let selector = '#dvPreviewContent';

                $(selector).html("<div class=\"loading-animation\"><span></span><span></span><span></span><span></span></div>");

                canvasService.getPreview(eId)
                    .then(function ({data}) {
                        if (data.Response.ID) {
                            var obj = data.Response;
                            var content = obj.TemplateContent;

                            if (content.indexOf("<!-- /Footer Path -->") != -1) {
                                content = content.substring(0, content.indexOf("<!-- /Footer Path -->"));
                            }

                            $(selector).html("");
                            var iframe = document.createElement('iframe');

                            $(iframe).attr("id", "ifrPreviewContent");
                            $(selector).append(iframe);
                            iframe.contentWindow.document.open();
                            iframe.contentWindow.document.write(content);
                            iframe.contentWindow.document.close();

                        } else {
                            alert("Could not load Preview");
                        }
                    });
            };

            $scope.parseEmailTitle = function (desc, limit) {
                if (desc) {
                    if ( desc.length > limit) {
                        desc = desc.slice(0, limit) + '...';
                    }
                }

                return desc;
            };

            //APro Node Metrics Pagination
            $scope.metricsPagination = {
                currentPage: 0,
                pageSize: '10',
                pages: 0,
                pageLimit: 3,
                previousPage: function () {
                    $scope.metricsPagination.currentPage--;
                    $scope.showMetricNodeDetail($scope.currentMetricType);
                },
                nextPage: function () {
                    $scope.metricsPagination.currentPage++;
                    $scope.showMetricNodeDetail($scope.currentMetricType);
                },
                changePageSize: function () {
                    $scope.metricsPagination.currentPage = 0;
                    $scope.showMetricNodeDetail($scope.currentMetricType);
                },
                getEndPage: function () {
                    let start;
                    if (($scope.metricsPagination.currentPage - $scope.metricsPagination.pageLimit) < 0) {
                        start = 0;
                    } else {
                        start = $scope.metricsPagination.currentPage;
                    }
                    const end = start + ($scope.metricsPagination.pageLimit);
                    if (end > $scope.metricsPagination.pages) {
                        return $scope.metricsPagination.pages;
                    }
                    return end;
                },
                getStartPage: function () {
                    const start = $scope.metricsPagination.getEndPage() - ($scope.metricsPagination.pageLimit);
                    if (start < 0) {
                        return 0;
                    }
                    return start;
                },
                getPageNumbers: function () {
                    const pageArray = [];
                    for (let page = $scope.metricsPagination.getStartPage(); page < $scope.metricsPagination.getEndPage(); page += 1) {
                        pageArray.push(page);
                    }
                    return pageArray;
                },
                goToPage: function (page) {
                    $scope.metricsPagination.currentPage = page;
                    $scope.showMetricNodeDetail($scope.currentMetricType);
                }
            }

            //APro metrics Search
            $scope.metricsSearch = {
                value: '',
                isActive: false,
                expanded: false,
                toggleSearch: function () {
                    if ($scope.metricsSearch.expanded && $scope.metricsSearch.value.length > 0) {
                        return;
                    }

                    $scope.metricsSearch.isActive = !$scope.metricsSearch.isActive;

                    if ($scope.metricsSearch.isActive) {
                        window.document.getElementById('search-metrics-input').focus();
                    }
                },
                toggleInput: function () {
                    if ($scope.metricsSearch.expanded && $scope.metricsSearch.value.length > 0)
                    {
                        return;
                    }

                    if ($scope.metricsSearch.value.length == 0) {
                        $scope.metricsSearch.isActive = false;
                    }
                },
                clearInput: function () {
                    $scope.metricsSearch.isActive = false;
                    $scope.metricsSearch.value = '';

                    $scope.metricsSearch.execute();
                },
                execute: function () {
                    $scope.metricsPagination.currentPage = 0;
                    $scope.showMetricNodeDetail($scope.currentMetricType);
                },
            };

            $scope.$watch('metricsSearch.value', function (newVal, oldVal) {
                if (newVal != oldVal) {
                    $scope.metricsSearch.execute();
                }
            });
        }]);
})();



// WEBPACK FOOTER //
// ./app/controllers/modals/summaryController.js